import React, { useState, useRef } from 'react';
import SvgIcon from '../svg-icon/svg-icon.component';
import './Input.styles.scss';

const Input = (props) => {
	const { value, onChange, leftIconValue, iconValue, iconClick, delay, allowClear, validation, ...other } = props;
	const [length, setLength] = useState(value?.length ? value?.length : 0);
	const timeout = useRef();
	const inputRef = useRef();

	const handleChange = (e) => {
		setLength(e.target?.value?.length);
		if (delay) {
			clearTimeout(timeout.current);

			timeout.current = setTimeout(() => {
				onChange(e);
			}, delay);
		} else {
			onChange(e);
		}
	};

	const clearInput = () => {
		setLength(0);
		clearTimeout(timeout.current);
		inputRef.current.value = '';
		onChange({ target: { name: other.name, value: '' } });
	};

	return (
		<div className={`formInput ${iconValue ? 'withIcon' : ''} ${leftIconValue ? 'withLeftIcon' : ''}`}>
			{leftIconValue && <div className="leftIcon">{leftIconValue}</div>}
			<input
				ref={(e) => {
					if (validation) validation(e);
					inputRef.current = e;
				}}
				type="text"
				{...other}
				//value={value ? value : ''}
				value={value}
				onChange={handleChange}
				autoComplete="off"
			/>
			{iconValue && (
				<div onClick={() => (iconClick ? iconClick(value) : null)} className={`rightIcon ${iconClick ? 'clickable' : ''}`}>
					{iconValue}
				</div>
			)}

			{allowClear && length > 0 && (
				<div className="clearButton" onClick={() => clearInput()}>
					<SvgIcon icon="icon-ios-close-empty" />
				</div>
			)}
		</div>
	);
};

export default Input;
